module.exports = __webpack_public_path__ + "img/Vinje_Graut_på_grut.480d12e0.jpg";